import React from 'react';

export interface ContentsItem {
  level: 'h2' | 'h3';
  text: string;
  id: string;
}

interface TableOfContentsProps {
  items: ContentsItem[];
}

function TableOfContents({ items }: TableOfContentsProps) {
  return (
    <nav className="blog-contents-sidebar" aria-label="Contents">
      <p className="blog-contents-sidebar__title">Contents</p>
      <ul className="blog-contents-sidebar__list">
        {items.map((item) => (
          <li
            key={item.id}
            className={`blog-contents-sidebar__item blog-contents-sidebar__item--${item.level}`}
          >
            <a href={`#${item.id}`} className="blog-contents-sidebar__link">
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default TableOfContents;
